import { faUserPen } from "@fortawesome/pro-light-svg-icons/faUserPen";
import { faUserPlus } from "@fortawesome/pro-light-svg-icons/faUserPlus";
import { faUsers } from "@fortawesome/pro-light-svg-icons/faUsers";
import { faPencil } from "@fortawesome/pro-light-svg-icons/faPencil";
import { faSignOut } from "@fortawesome/pro-light-svg-icons/faSignOut";
import { faChevronRight } from "@fortawesome/pro-light-svg-icons/faChevronRight";
import { faChevronLeft } from "@fortawesome/pro-light-svg-icons/faChevronLeft";
import { faTimes } from "@fortawesome/pro-light-svg-icons/faTimes";

export default [
	faUserPen, faUserPlus, faUsers, faPencil, faSignOut, faChevronLeft, faChevronRight, faTimes
];
